import { render } from "./Proveedor_Catalogo.vue?vue&type=template&id=6116ba3e"
import script from "./Proveedor_Catalogo.vue?vue&type=script&lang=js"
export * from "./Proveedor_Catalogo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__